



























































import { numberHigherRule } from "@/lib/rules/numberHigherRule";
import { IWorkshopContractRate, WorkshopContractRate } from "@/models/workshop-contract-rate.entity";
import { Component, Prop, Vue, Watch } from "vue-property-decorator";

@Component
export default class WorkshopContractForm extends Vue {
  @Prop({ required: true }) value!: IWorkshopContractRate;
  @Prop({ default: false }) isEditing!: boolean;

  localDetails: IWorkshopContractRate = new WorkshopContractRate({});

  @Watch("value", { immediate: true, deep: true })
  onDetailsChange(val: IWorkshopContractRate) {
    this.localDetails = val;
  }
  @Watch("localDetails", { deep: true })
  onLocalDetailsChange() {
    this.$emit("update:value", this.localDetails);
  }

  onFieldChanged(labelKey: string) {
    if (!this.isEditing) return;
    this.$emit("field-changed", labelKey);
  }

  get greaterThanZeroRule() {
    return [numberHigherRule(0)];
  }

  get isRelativeValueRule() {
    return [numberHigherRule(0)];
  }
}
